import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_128_add_vendor: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Add vendor",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "Supplier_Add",
        TableName: "supplier_details",
        columnNumber: "m1 t1 w3",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        childComponents: [
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "vin_number",
            label: "Code",
            placeholder: "Will be auto generated...",
            required: false,
            inputType: InputType.TEXT,
            disabled: true,
            Json_Attribute: "code",
            AutoPopulate: true,
            AutoPopulate_format: "SUP_[******]",
            showInSummary: true,
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_suppliername",
            label: "Vendor name",
            placeholder: "",
            required: true,
            inputType: InputType.TEXT,
            Json_Attribute: "suppliername",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Vendor name is required",
              },
            ],
          },
          {
            componentType: ComponentType.RADIO_FIELD,
            name: "check_vat_exemption_box",
            label: "Vat exemption?",
            placeholder: "",
            required: false,
            options: [
              { label: "Yes", value: true },
              { label: "No", value: false },
            ],
            defaultValue: false,
            Json_Attribute: "vat_exemption_box",
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "numeric_supplierphone",
            label: "Phone",
            placeholder: "",
            required: false,
            inputType: InputType.PHONE,
            Json_Attribute: "supplierphone",
            validation: [
              {
                rule: ValidationRule.PATTERN,
                value: "^[0-9]+$",
                message: "Only numbers are allowed",
              },
            ],
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "numeric_suppliermobile",
            label: "Mobile",
            placeholder: "",
            required: true,
            inputType: InputType.PHONE,
            Json_Attribute: "suppliermobile",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Mobile is required",
              },
              {
                rule: ValidationRule.PATTERN,
                value: "^[0-9]+$",
                message: "Only numbers are allowed",
              },
            ],
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_supplieremail",
            label: "Email",
            placeholder: "",
            required: false,
            inputType: InputType.EMAIL,
            Json_Attribute: "supplieremail",
            validation: [
              {
                rule: ValidationRule.PATTERN,
                value: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
                message: "Invalid email format",
              },
            ],

          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_supplierweb",
            label: "Web",
            placeholder: "",
            required: false,
            inputType: InputType.URL,
            Json_Attribute: "supplierweb",
            validation: [
              {
                rule: ValidationRule.PATTERN,
                value: "^(https?:\\/\\/)?([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}(\/.*)?$",
                message: "Invalid URL format",
              },
            ],

          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_supplieraddress",
            label: "Vendor address",
            placeholder: "",
            required: false,
            inputType: InputType.TEXT,
            Json_Attribute: "supplieraddress",
            
          },
          {
            componentType: ComponentType.SEARCHABLE_DROPDOWN,
            name: "select_country",
            label: "Country",
            placeholder: "",
            required: false,
            lookupName: "country",
            options: [],
            searchable: true,
            clearable: true,
            Json_Attribute: "supplier_country",
          },
          {
            componentType: ComponentType.SEARCHABLE_DROPDOWN,
            name: "select_supplierstate",
            label: "Emirates/State/Province",
            placeholder: "",
            required: false,
            lookupName: "state",
            parentField: "select_country",
            options: [],
            searchable: true,
            clearable: true,
            Json_Attribute: "supplierstate",
          },
          {
            componentType: ComponentType.SEARCHABLE_DROPDOWN,
            name: "select_locationpermissions",
            label: "City",
            placeholder: "",
            required: false,
            lookupName: "city",
            parentField: "select_supplierstate",
            options: [],
            searchable: true,
            clearable: true,
            Json_Attribute: "locationpermissions",
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_creditdays",
            label: "Credit days",
            placeholder: "",
            required: false,
            inputType: InputType.NUMBER,
            Json_Attribute: "creditdays",
            validation: [
              {
                rule: ValidationRule.PATTERN,
                value: "^(?:0|[1-9][0-9]?|[12][0-9]{2}|3[0-5][0-9]|36[0-5])(?:\\.0)?$",
                message: "Value must be between 0 and 365",
              },
            ],
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_creditamount",
            label: "Credit amount",
            placeholder: "",
            required: false,
            inputType: InputType.NUMBER,
            Json_Attribute: "creditamount",
          },
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_taxregno",
            label: "TRN",
            placeholder: "",
            required: false,
            inputType: InputType.TEXT,
            Json_Attribute: "taxregno",
          },
          {
            componentType: ComponentType.FILES,
            name: "file_vat_certificate",
            label: "VAT certificate",
            placeholder: "",
            required: false,
            Json_Attribute: "vat_certificate_attachment",
            IsVerticalView: true,
            validation: [
              {
                rule: ValidationRule.CONDITIONAL_REQUIRED,
                whenField: "check_vat_exemption_box",
                whenValue: "false",
                message: "VAT certificate is required when VAT exemption is No",
              },
            ],
          },
          {
            componentType: ComponentType.FILES,
            name: "credit_application_form",
            label: "Credit application form",
            placeholder: "",
            required: false,
            Json_Attribute: "credit_application_form_attachment",
            IsVerticalView: true,
          },
          {
            componentType: ComponentType.FILES,
            name: "file_trade_license",
            label: "Trade license",
            placeholder: "",
            required: false,
            Json_Attribute: "trade_license_attachment",
            IsVerticalView: true,
          },
          {
            componentType: ComponentType.FILES,
            name: "file_others",
            label: "Others",
            placeholder: "",
            required: false,
            Json_Attribute: "Others_attachment",
            IsVerticalView: true,
          },
        ],
      },
      {
        componentType: ComponentType.BUTTON,
        name: "Save",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
        },
      },
    ],
  },
];
